import React from "react";
import {
  FormLabel,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  Flex,
} from "@chakra-ui/react";

export const InputNumber = ({
  maxW,
  defaultValue,
  label,
  setValue,
  value,
  type,
  max,
}) => {
  return (
    <Flex alignItems={"center"} justifyContent="center" marginBottom={30}>
      <FormLabel>{label}</FormLabel>
      <NumberInput
        size="md"
        maxW={maxW}
        min={0}
        defaultValue={defaultValue}
        max={max}
        onChange={(valueString) => setValue(valueString, type)}
        value={value}
      >
        <NumberInputField />
        <NumberInputStepper>
          <NumberIncrementStepper />
          <NumberDecrementStepper />
        </NumberInputStepper>
      </NumberInput>
    </Flex>
  );
};
